/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const UserBubble = styled(Box)(({theme}) => ({
  alignSelf: 'flex-end',
  backgroundColor: theme.palette.semantic_dark?.primary.container,
  color: theme.palette.semantic_dark?.primary.onContainer,
  borderRadius: '12px',
  padding: theme.spacing(3, 4),
  maxWidth: '70%',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}));

export const FailedBubble = styled(Box)(({theme}) => ({
  alignSelf: 'flex-start',
  backgroundColor: theme.palette.semantic_dark?.bad.container,
  color: theme.palette.semantic_dark?.bad.onContainer,
  borderRadius: '12px',
  padding: theme.spacing(3, 4),
  maxWidth: '70%',
  wordBreak: 'break-word',
}));

export const AssistantBubble = styled(Box)(({theme}) => ({
  alignSelf: 'flex-start',
  backgroundColor: theme.palette.semantic_dark?.surface.surface2,
  color: theme.palette.semantic_dark?.surface.onSurface,
  borderRadius: '12px',
  padding: theme.spacing(3, 4),
  maxWidth: '70%',
  wordBreak: 'break-word',

  '& h1': {
    fontSize: '24px',
    fontWeight: 700,
    margin: `${theme.spacing(2)} 0`,
  },
  '& h2': {
    fontSize: '20px',
    fontWeight: 700,
    margin: `${theme.spacing(2)} 0`,
  },
  '& h3': {
    fontSize: '18px',
    fontWeight: 600,
    margin: `${theme.spacing(2)} 0`,
  },
  '& h4, & h5, & h6': {
    fontSize: '16px',
    fontWeight: 600,
    margin: `${theme.spacing(2)} 0`,
  },
  '& p': {
    margin: `${theme.spacing(1)} 0`,
    lineHeight: 1.6,
  },
  '& ul, & ol': {
    paddingLeft: theme.spacing(5),
    margin: `${theme.spacing(1)} 0`,
  },
  '& li': {
    marginBottom: theme.spacing(1),
  },
  '& code': {
    backgroundColor: theme.palette.semantic_dark?.surface.surface3,
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    borderRadius: '4px',
    fontSize: '13px',
  },
  '& pre': {
    backgroundColor: theme.palette.semantic_dark?.surface.surface3,
    padding: theme.spacing(3),
    borderRadius: '8px',
    overflowX: 'auto',
    margin: `${theme.spacing(2)} 0`,

    '& code': {
      backgroundColor: 'transparent',
      padding: 0,
    },
  },
  '& blockquote': {
    borderLeft: `3px solid ${theme.palette.semantic_dark?.surface.onSurfaceMuted}`,
    paddingLeft: theme.spacing(3),
    margin: `${theme.spacing(2)} 0`,
    color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  },
  '& table': {
    borderCollapse: 'collapse',
    width: '100%',
    margin: `${theme.spacing(2)} 0`,
  },
  '& th, & td': {
    border: `1px solid ${theme.palette.semantic_dark?.surface.onSurfaceMuted}`,
    padding: theme.spacing(2),
    textAlign: 'left',
  },
  '& th': {
    backgroundColor: theme.palette.semantic_dark?.surface.surface3,
    fontWeight: 600,
  },
  '& a': {
    color: theme.palette.semantic_dark?.primary.main,
    textDecoration: 'underline',

    '&:hover': {
      color: theme.palette.semantic_dark?.primary.hover,
    },
  },
  '& img': {
    display: 'none',
  },
}));
